document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const tabContents = document.querySelectorAll(".tab-content");
  const carousels = document.querySelectorAll(".carousel-wrapper");

  function updateArrows(wrapper) {
    const track = wrapper.querySelector(".carousel-track");
    const prevButton = wrapper.querySelector(".carousel-prev");
    const nextButton = wrapper.querySelector(".carousel-next");

    if (!track || !prevButton || !nextButton) return;

    // Disable left arrow at start
    prevButton.disabled = track.scrollLeft <= 0;

    // Disable right arrow at end
    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    nextButton.disabled = track.scrollLeft >= maxScrollLeft - 1;
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const tab = button.dataset.tab;

      tabButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      tabContents.forEach((content) => {
        if (content.dataset.content === tab) {
          content.classList.add("active");
          const wrapper = content.querySelector(".carousel-wrapper");
          if (wrapper) updateArrows(wrapper);
        } else {
          content.classList.remove("active");
        }
      });

      // ✅ Scroll the clicked tab into view (on mobile only)
      if (window.innerWidth <= 768) {
        button.scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest"
        });
      }
    });
  });

  carousels.forEach((wrapper) => {
    const track = wrapper.querySelector(".carousel-track");
    const prevButton = wrapper.querySelector(".carousel-prev");
    const nextButton = wrapper.querySelector(".carousel-next");

    // Initial check
    updateArrows(wrapper);

    // Scroll by clicking arrows
    prevButton.addEventListener("click", () => {
      track.scrollBy({ left: -350, behavior: "smooth" });
    });

    nextButton.addEventListener("click", () => {
      track.scrollBy({ left: 350, behavior: "smooth" });
    });

    track.addEventListener("scroll", () => updateArrows(wrapper));
    window.addEventListener("resize", () => updateArrows(wrapper));
  });
});
